/*!
 * Session Timeout Dialog Component
 * Location: alfresco-content-app/app/src/app/components/session-timeout/session-timeout-dialog.component.ts
 * 
 * Shows a warning dialog when session is about to expire
 */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SessionTimeoutService } from './session-timeout.service';

@Component({
  selector: 'app-session-timeout-dialog',
  templateUrl: './session-timeout-dialog.component.html',
  styleUrls: ['./session-timeout-dialog.component.scss']
})
export class SessionTimeoutDialogComponent implements OnInit, OnDestroy {
  
  showDialog = false;
  remainingSeconds = 0;
  remainingMinutes = 0;
  remainingSecondsDisplay = 0;
  
  private destroy$ = new Subject<void>();
  
  constructor(private sessionService: SessionTimeoutService) {}
  
  ngOnInit(): void {
    // Subscribe to warning events
    this.sessionService.onWarning$
      .pipe(takeUntil(this.destroy$))
      .subscribe(seconds => {
        this.remainingSeconds = seconds;
        this.remainingMinutes = Math.floor(seconds / 60);
        this.remainingSecondsDisplay = seconds % 60;
        this.showDialog = true;
      });
    
    // Subscribe to session extended events
    this.sessionService.onSessionExtended$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.showDialog = false;
      });
    
    // Subscribe to timeout events
    this.sessionService.onTimeout$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.showDialog = false;
      });
  }
  
  /**
   * User clicked "Stay Logged In"
   */
  extendSession(): void {
    this.sessionService.extendSession();
    this.showDialog = false;
  }
  
  /**
   * User clicked "Logout"
   */
  logout(): void {
    this.showDialog = false;
    this.sessionService.logout('User logged out');
  }
  
  /**
   * Format time for display
   */
  formatTime(): string {
    if (this.remainingMinutes > 0) {
      return `${this.remainingMinutes}:${this.remainingSecondsDisplay.toString().padStart(2, '0')}`;
    }
    return `${this.remainingSecondsDisplay} seconds`;
  }
  
  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}